/**
 * Nidra Search Modal & Predictive Search
 * Recreates Lovable SearchOverlay with native Shopify Predictive Search
 */
(function() {
  const defaultItems = [
    { label: "Nidra Cervical Memory Foam Pillow", kind: "Product", url: "/products/nidra-cervical-memory-foam-pillow" },
    { label: "Size Guide — find your S, M or L", kind: "Page", url: "/pages/size-guide" },
    { label: "Customer Experiences", kind: "Page", url: "/pages/reviews" },
    { label: "Our Philosophy", kind: "Page", url: "/pages/our-philosophy" },
    { label: "Frequently asked questions", kind: "Page", url: "/pages/faq" },
    { label: "The Journal", kind: "Page", url: "/blogs/journal" },
    { label: "Best Pillow for Neck Pain: How to Choose the Right One", kind: "Journal", url: "/blogs/journal/best-pillow-for-neck-pain" },
    { label: "Cervical Pillow vs Regular Pillow: The Structural Differences", kind: "Journal", url: "/blogs/journal/cervical-pillow-vs-regular-pillow" },
    { label: "Memory Foam Pillow for Neck Pain: Density, Loft, and Relief", kind: "Journal", url: "/blogs/journal/memory-foam-pillow-for-neck-pain" }
  ];

  class SearchManager {
    constructor() {
      this.overlay = document.getElementById('SearchModalOverlay');
      this.panel = document.getElementById('SearchModalPanel');
      this.input = document.getElementById('SearchModalInput');
      this.list = document.getElementById('SearchResultsList');
      this.closeBtn = document.getElementById('SearchModalClose');
      this.openBtn = document.getElementById('SearchModalOpen');
      this.isOpen = false;

      this.initEvents();
    }

    initEvents() {
      if (this.openBtn) {
        this.openBtn.addEventListener('click', (e) => {
          e.preventDefault();
          this.open();
        });
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) this.close();
        });
      }

      if (this.input) {
        this.input.addEventListener('input', (e) => {
          this.handleSearch(e.target.value.trim());
        });
      }

      window.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen) this.close();
      });
    }

    open() {
      if (!this.overlay) return;
      this.isOpen = true;
      this.overlay.style.display = 'grid';
      document.body.style.overflow = 'hidden';
      if (this.input) {
        this.input.value = '';
        this.input.focus();
      }
      this.renderResults(defaultItems.slice(0, 6));
    }

    close() {
      if (!this.overlay) return;
      this.isOpen = false;
      this.overlay.style.display = 'none';
      document.body.style.overflow = '';
    }

    async handleSearch(query) {
      if (!query) {
        this.renderResults(defaultItems.slice(0, 6));
        return;
      }

      // Filter default items first
      const localMatches = defaultItems.filter(item => item.label.toLowerCase().includes(query.toLowerCase()));

      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,article,page&resources[limit]=6`);
        if (res.ok) {
          const data = await res.json();
          const remoteResults = [];
          if (data.resources && data.resources.results) {
            const r = data.resources.results;
            (r.products || []).forEach(p => remoteResults.push({ label: p.title, kind: 'Product', url: p.url }));
            (r.articles || []).forEach(a => remoteResults.push({ label: a.title, kind: 'Journal', url: a.url }));
            (r.pages || []).forEach(pg => remoteResults.push({ label: pg.title, kind: 'Page', url: pg.url }));
          }

          const combined = [...localMatches];
          remoteResults.forEach(rem => {
            if (!combined.some(c => c.label.toLowerCase() === rem.label.toLowerCase())) {
              combined.push(rem);
            }
          });

          this.renderResults(combined);
          return;
        }
      } catch (err) {
        console.warn('Predictive search fallback to local:', err);
      }

      this.renderResults(localMatches);
    }

    renderResults(items) {
      if (!this.list) return;

      if (!items || items.length === 0) {
        this.list.innerHTML = '<li class="empty">No matches. Try “neck pain”, “size” or “reviews”.</li>';
        return;
      }

      let html = '';
      items.slice(0, 8).forEach(item => {
        html += `
          <li>
            <button type="button" onclick="window.location.href='${item.url}'">
              <b>${item.label}</b>
              <small>${item.kind}</small>
            </button>
          </li>
        `;
      });
      this.list.innerHTML = html;
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    window.NidraSearch = new SearchManager();
  });
})();
